import { Injectable } from '@angular/core';
import { Toast } from 'bootstrap';

@Injectable()
export class SuccessService {

  private readonly successToastElement: HTMLElement | undefined;
  private successToast: Toast | undefined;

  constructor() {
    this.successToastElement = document.getElementById('successToast') as HTMLElement;
    this.successToast = new Toast(this.successToastElement);
  }

  public showSuccessToast(message:string){
    const toastMsg=  window.document.getElementById('successToastMsg') as HTMLElement;
    toastMsg.textContent = message !== undefined ? message : 'Done';
    this.successToast?.show();
  }
}
